export const extractDottedLevelsFromObject = (s: string) => {
    return (item: any) => {
        let currentObject = item;
        if (currentObject) {
            const segments = s.split(".");
            let failed = false;
            for (let i = 0; i < segments.length; i++) {
                const segment = segments[i];
                if (currentObject[segment]) {
                    currentObject = currentObject[segment];
                } else {
                    failed = true;
                    break;
                }
            }

            return failed ? "" : currentObject;
        }
    };
};
